module.exports = __webpack_public_path__ + "static/roadmap2012-5a11e6d0c3879f72652cb00580b70445.svg";